import { getStorage } from '@/plugins/Store/locationStorage'
import { STORE_TOKEN } from './storage'

export default {
  pending: false,
  token: getStorage().getItem(STORE_TOKEN)
}
